import React, { useState } from 'react'
import { Group, Paper, Title } from '@mantine/core'
import axios from 'axios'
import { AppButton } from '@gunslop/ui'
import { resolveApiBaseUrl } from '../../app/api/resolveApiBaseUrl'
import ValidationErrors from './ValidationErrors'

export default function TestErrors () {
  const baseUrl = resolveApiBaseUrl()
  const [errors, setErrors] = useState<unknown>(null)

  function handleNotFound () {
    axios.get(`${baseUrl}/buggy/not-found`).catch((err) => console.log(err.response))
  }

  function handleBadRequest () {
    axios.get(`${baseUrl}/buggy/bad-request`).catch((err) => console.log(err.response))
  }

  function handleServerError () {
    axios.get(`${baseUrl}/buggy/server-error`).catch((err) => console.log(err.response))
  }

  function handleUnauthorised () {
    axios.get(`${baseUrl}/buggy/unauthorised`).catch((err) => console.log(err.response))
  }

  function handleBadGuid () {
    axios.get(`${baseUrl}/activities/notaguid`).catch((err) => console.log(err.response))
  }

  function handleValidationError () {
    axios.post(`${baseUrl}/activities`, {}).catch((err) => setErrors(err))
  }

  return (
    <>
      <Title order={1} mb="md">Test Error component</Title>
      <Paper p="md" withBorder>
        <Group spacing="xs">
          <AppButton variant="outline" onClick={handleNotFound}>Not Found</AppButton>
          <AppButton variant="outline" onClick={handleBadRequest}>Bad Request</AppButton>
          <AppButton variant="outline" onClick={handleValidationError}>Validation Error</AppButton>
          <AppButton variant="outline" onClick={handleServerError}>Server Error</AppButton>
          <AppButton variant="outline" onClick={handleUnauthorised}>Unauthorised</AppButton>
          <AppButton variant="outline" onClick={handleBadGuid}>Bad Guid</AppButton>
        </Group>
      </Paper>
      {errors != null && <ValidationErrors errors={errors as Parameters<typeof ValidationErrors>[0]['errors']} />}
    </>
  )
}
